var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "promocode-list"
  }, [_c('p', {
    staticClass: "promocode-list__title"
  }, [_vm._v("\n    Активные промокоды\n  ")]), _vm._v(" "), _vm._l(_vm.list, function (el, index) {
    return _c('div', {
      key: index,
      staticClass: "promocode-list__el"
    }, [_c('div', {
      staticClass: "promocode-list__left"
    }, [_c('p', {
      staticClass: "promocode-list__name"
    }, [_vm._v("\n        " + _vm._s(el.coupon ? el.coupon : 'Без названия') + "\n      ")]), _vm._v(" "), _c('p', {
      staticClass: "promocode-list__text"
    }, [_vm._v("\n        " + _vm._s(el.description ? ("По акции «" + (el.description) + "», ") : null) + " " + _vm._s(el.status) + "\n      ")])]), _vm._v(" "), _c('div', {
      staticClass: "promocode-list__right"
    }, [_c('p', {
      staticClass: "link link_wu link_blue",
      on: {
        "click": function ($event) {
          return _vm.emit('remove', el.coupon);
        }
      }
    }, [_vm._v("\n        Удалить\n      ")])])]);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }